<template>
  <div>
    <div class="help-desk-information-box rounded-circle text-blue-500 pb-3 pb-md-0 d-flex" v-once>
      <div class="my-auto mx-auto justify-center">
        <img
          :src="emailImage"
          style="max-width: 60px"
          alt="HelpDesk Kontakt"
          class="d-none d-md-block mx-auto mb-2"
        />
        <p class="px-2 px-md-4 text-center font-weight-bold mb-0">
          <span
            class="d-none d-md-block"
            v-html="$t('form.typeOfSupport.helpDesk.titleDesktop')"
          ></span>
          <span class="d-block d-md-none">{{ $t('form.typeOfSupport.helpDesk.titleMobile') }}</span>
        </p>
        <p class="px-4 text-center mb-3">
          {{ $t('form.typeOfSupport.helpDesk.subtitle') }}
        </p>
        <a
          :href="'mailto:' + $t('form.typeOfSupport.helpDesk.description.mail')"
          class="d-block mb-0 text-center"
        >
          {{ $t('form.typeOfSupport.helpDesk.description.mail') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emailImage = new URL('/src/assets/svg/email.svg', import.meta.url).href
</script>
